import React, { useState, useEffect } from 'react';
import Layout from '../../components/Layout';
import TicketsPerBankView from './TicketsPerBankView';
import { fetchMoveDetail } from '../../api/salesMonitoring';
import './MoveDetailView.css';

const MoveDetailView = ({ row, date, rawDate, tirage, tirageName, filter, scopeId, onBack }) => {
  const [selectedBank, setSelectedBank] = useState(null);
  const [detail, setDetail] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError('');
    fetchMoveDetail({ tirage, date: rawDate, product: row.game, numbers: row.numero, filter, scope: scopeId })
      .then((data) => { if (!cancelled) setDetail(data); })
      .catch(() => { if (!cancelled) setError('Impossible de charger le detail — verifie que le serveur backend tourne.'); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [tirage, rawDate, row.game, row.numero, filter, scopeId]);

  if (selectedBank) {
    return (
      <TicketsPerBankView
        row={selectedBank}
        product={row.game}
        numero={row.numero}
        date={date}
        rawDate={rawDate}
        tirage={tirage}
        onBack={() => setSelectedBank(null)}
      />
    );
  }

  const totalTickets = detail.reduce((s, r) => s + r.tickets, 0);
  const totalSold    = detail.reduce((s, r) => s + r.sold, 0);
  const totalAmount  = detail.reduce((s, r) => s + r.amount, 0);

  const limit     = 30000;
  const posted    = row.value;
  const available = limit - posted;

  return (
    <Layout>
      <div className="mdv-wrapper">
        {/* Carte principale */}
        <div className="mdv-card">
          <div className="mdv-card-header">
            <span className="mdv-card-title">Move's Detail</span>
          </div>

          <div className="mdv-info">
            <div className="mdv-info-left">
              <div className="mdv-numero-row">
                <span className="mdv-borlette-label">{row.game} :</span>
                <span className="mdv-numero-val">{row.numero}</span>
              </div>
              <div className="mdv-info-row">
                <span className="mdv-info-label">Date:</span>
                <span className="mdv-info-box">{date}</span>
              </div>
              <div className="mdv-info-row">
                <span className="mdv-info-label">Lottery:</span>
                <span className="mdv-info-box">{tirageName}</span>
              </div>
            </div>
            <div className="mdv-info-right">
              <div className="mdv-limit-row">
                <span className="mdv-limit-label">Limit:</span>
                <span className="mdv-limit-val">{limit.toLocaleString()}</span>
              </div>
              <div className="mdv-limit-row">
                <span className="mdv-limit-label">Posted:</span>
                <span>{Math.round(posted).toLocaleString()}</span>
              </div>
              <div className="mdv-limit-row">
                <span className="mdv-limit-label">Available:</span>
                <span>{Math.round(available).toLocaleString()}</span>
              </div>
            </div>
          </div>

          <div className="mdv-table-header-bar"></div>

          {error && <p className="mdv-error">{error}</p>}
          {loading && <p className="mdv-loading">Chargement...</p>}

          {!loading && !error && (
            <table className="mdv-table">
              <thead>
                <tr>
                  <th>Bank</th>
                  <th>Description</th>
                  <th>Tickets</th>
                  <th>Sold</th>
                  <th>Amount</th>
                </tr>
              </thead>
              <tbody>
                {detail.map((r, i) => (
                  <tr key={i} className={i % 2 === 0 ? 'mdv-row-even' : 'mdv-row-odd'}>
                    <td><span className="mdv-bank-box">{r.bank_seq ?? r.bank}</span></td>
                    <td>
                      <span
                        className="mdv-desc-box mdv-desc-link"
                        onClick={() => setSelectedBank(r)}
                      >{r.desc}</span>
                    </td>
                    <td>{r.tickets}</td>
                    <td>{r.sold.toFixed(2)}</td>
                    <td>{r.amount.toFixed(2)}</td>
                  </tr>
                ))}
                <tr className="mdv-total-row">
                  <td colSpan="2"><strong>Total</strong></td>
                  <td><strong>{totalTickets}</strong></td>
                  <td><strong>{totalSold.toFixed(2)}</strong></td>
                  <td><strong>{totalAmount.toFixed(2)}</strong></td>
                </tr>
              </tbody>
            </table>
          )}
        </div>

        {/* Boutons droite */}
        <div className="mdv-actions">
          <button className="mdv-back-btn" onClick={onBack}>↩</button>
          <button className="mdv-menu-btn">☰<br/><span>Menu</span></button>
        </div>
      </div>
    </Layout>
  );
};

export default MoveDetailView;
